var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisibilityDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3519_69454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3.63519C5.56091 3.63519 2.44216 5.51675 0.140841 8.5729C-0.0469469 8.82329 -0.0469469 9.17309 0.140841 9.42347C2.44216 12.4833 5.56091 14.3649 9 14.3649C12.4391 14.3649 15.5578 12.4833 17.8592 9.42715C18.0469 9.17677 18.0469 8.82697 17.8592 8.57659C15.5578 5.51675 12.4391 3.63519 9 3.63519ZM9.2467 12.7779C6.96379 12.9215 5.07855 11.0399 5.22215 8.75333C5.33998 6.86809 6.86806 5.34001 8.7533 5.22218C11.0362 5.07858 12.9214 6.96014 12.7778 9.24673C12.6563 11.1283 11.1283 12.6564 9.2467 12.7779ZM9.13256 11.0326C7.90273 11.1099 6.88647 10.0973 6.96747 8.86747C7.03007 7.85121 7.85486 7.0301 8.87113 6.96382C10.101 6.8865 11.1172 7.89908 11.0362 9.1289C10.9699 10.1488 10.1451 10.97 9.13256 11.0326Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3519_69454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityDark);
export default __webpack_public_path__ + "static/media/ic_visibility_dark.f3d675e2c6cd4e029386e0531106636d.svg";
export { ForwardRef as ReactComponent };